import { isEmpty, uniqBy } from 'lodash';
import { MarketComparisonWritable } from 'api';
import { dbShortDate, getArrayValue, getStringValue } from 'utilities';
import { GetUniqueComparisonsParams } from './getUniqueComparisons.types';

const getUniqueComparisons = (params: GetUniqueComparisonsParams): MarketComparisonWritable[] => {
  const { comparisons, date, fallback } = params;

  const comparisonsByDate = getArrayValue(comparisons).filter(
    comparison => comparison?.as_of_date === dbShortDate(date)
  );

  if (isEmpty(comparisonsByDate) && !isEmpty(comparisons)) {
    return getArrayValue(fallback);
  }

  return uniqBy(comparisonsByDate, comparison => getStringValue(comparison?.cap_iq_id));
};

export default getUniqueComparisons;
